export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const GET = "GET";
export const POST = "POST";
export const PUT = "PUT";
export const DELETE = "DELETE";